import toast, { Renderable } from 'react-hot-toast'
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  InformationCircleIcon,
  XCircleIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import { cn } from 'shared/styles'

type ToastCustomType = 'success' | 'error' | 'warning' | 'info'

const iconsMap: Record<ToastCustomType, typeof CheckCircleIcon> = {
  error: XCircleIcon,
  info: InformationCircleIcon,
  success: CheckCircleIcon,
  warning: ExclamationCircleIcon,
}

const iconColorsMap: Record<ToastCustomType, string> = {
  error: 'stroke-red-600',
  info: 'stroke-blue-600',
  success: 'stroke-green-500',
  warning: 'stroke-red-600',
}

export function showToast(type: ToastCustomType, content: Renderable) {
  const IconPic = iconsMap[type]

  toast.custom((t) => (
    <div
      className={cn(
        'shadow-menu flex w-full max-w-md gap-3 rounded-md bg-white p-5',
        t.visible ? 'animate-enter' : 'animate-leave',
        type === 'info' && 'border-l-8 border-solid border-blue-600',
      )}
    >
      <IconPic
        className={cn('h-6 w-6 flex-none stroke-2', iconColorsMap[type])}
      />
      <p className='mt-0.5 mr-auto overflow-hidden leading-5 font-medium wrap-break-word whitespace-normal'>
        {content}
      </p>
      <XMarkIcon
        onClick={() => toast.dismiss(t.id)}
        className='mt-0.5 h-5 w-5 flex-none stroke-gray-500 stroke-2 hover:cursor-pointer hover:stroke-gray-800'
      />
    </div>
  ))
}
